import { useState, useEffect } from 'react';
import { getAllUsersFromStorage } from '../../../../utils/sharedStorage';

export default function RoueChance() {
  const [isSpinning, setIsSpinning] = useState(false);
  const [hasSpun, setHasSpun] = useState(false);
  const [winAmount, setWinAmount] = useState(0);
  const [referralsCount, setReferralsCount] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [currency, setCurrency] = useState('FCFA');
  const [userPhone, setUserPhone] = useState('');

  useEffect(() => {
    const spunBefore = localStorage.getItem('wheelSpunOnce');
    if (spunBefore === 'true') {
      setHasSpun(true);
      const savedWin = parseInt(localStorage.getItem('wheelWinAmount') || '0');
      setWinAmount(savedWin);
    }

    try {
      const raw = localStorage.getItem('currentUser');
      if (raw) {
        const userData = JSON.parse(raw);
        const phone = userData.phone || '';
        setUserPhone(phone);

        const country = userData.country || 'CI';
        const curr = country === 'CD' ? 'FC' : country === 'GH' ? 'GH₵' : 'FCFA';
        setCurrency(curr);

        // Compter les vrais filleuls depuis le storage
        const username = userData.username || userData.name || '';
        if (username) {
          const allUsers = getAllUsersFromStorage();
          const refs = allUsers.filter(u => u.referredBy === username && (u.isActivated || u.accountStatus === 'active'));
          setReferralsCount(refs.length);
        }
      }
    } catch { /* ignore */ }
  }, []);

  const handleSpin = () => {
    if (hasSpun || isSpinning) return;
    setIsSpinning(true);

    setTimeout(() => {
      const earned = 800;
      setWinAmount(earned);
      setHasSpun(true);
      setShowResult(true);

      localStorage.setItem('wheelSpunOnce', 'true');
      localStorage.setItem('wheelWinAmount', earned.toString());

      // Créditer les gains dans userProfits (toujours, pas de condition)
      try {
        const profits = JSON.parse(localStorage.getItem('userProfits') || '[]');
        profits.push({
          id: `wheel-${Date.now()}`,
          label: 'Roue de chance',
          amount: earned,
          date: new Date().toLocaleDateString('fr-FR'),
          type: 'roue',
          phone: userPhone,
        });
        localStorage.setItem('userProfits', JSON.stringify(profits));
      } catch { /* ignore */ }

      setIsSpinning(false);
    }, 3000);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl p-8 text-white shadow-lg">
        <h2 className="text-2xl font-bold mb-2">Roue de chance</h2>
        <p className="text-yellow-100">
          {hasSpun
            ? '✅ Vous avez déjà utilisé votre chance ! La roue ne peut être tournée qu\'une seule fois.'
            : 'Tournez la roue UNE SEULE FOIS et gagnez 800 ' + currency + ' !'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl p-8 shadow-lg">
          <div className="flex flex-col items-center">
            <div className={`w-64 h-64 rounded-full bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 flex items-center justify-center shadow-2xl ${isSpinning ? 'animate-spin' : ''}`}>
              <div className="w-56 h-56 rounded-full bg-white flex items-center justify-center">
                <div className="text-center">
                  {hasSpun ? (
                    <>
                      <i className="ri-check-double-line text-6xl text-green-500 mb-2"></i>
                      <p className="text-2xl font-bold text-gray-800">{winAmount} {currency}</p>
                      <p className="text-xs text-gray-500 mt-1">Gagné !</p>
                    </>
                  ) : (
                    <>
                      <i className="ri-trophy-line text-6xl text-yellow-500 mb-2"></i>
                      <p className="text-2xl font-bold text-gray-800">800 {currency}</p>
                    </>
                  )}
                </div>
              </div>
            </div>

            <button
              onClick={handleSpin}
              disabled={hasSpun || isSpinning}
              className={`mt-8 px-8 py-3 rounded-full font-bold text-lg transition whitespace-nowrap ${
                !hasSpun && !isSpinning
                  ? 'bg-gradient-to-r from-yellow-500 to-orange-500 text-white hover:shadow-lg cursor-pointer'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              {isSpinning ? 'En cours...' : hasSpun ? '🔒 Déjà utilisée' : 'Tourner la roue'}
            </button>

            {hasSpun && (
              <div className="mt-4 text-center bg-green-50 border border-green-200 rounded-xl px-6 py-3">
                <p className="text-sm font-bold text-green-700">
                  ✅ Vous avez gagné <span className="text-lg">{winAmount} {currency}</span>
                </p>
                <p className="text-xs text-gray-500 mt-1">Gains ajoutés à votre solde Points.</p>
              </div>
            )}
          </div>
        </div>

        <div className="space-y-4">
          <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg">
            <i className="ri-money-dollar-circle-line text-4xl mb-2"></i>
            <p className="text-green-100 text-sm">Gains de la roue</p>
            <p className="text-4xl font-bold mt-2">{winAmount.toLocaleString()} {currency}</p>
          </div>

          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl p-6 text-white shadow-lg">
            <i className="ri-user-add-line text-4xl mb-2"></i>
            <p className="text-orange-100 text-sm">Filleuls actifs</p>
            <p className="text-4xl font-bold mt-2">{referralsCount}</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <h3 className="font-bold text-gray-800 mb-3">Comment ça marche ?</h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
                <span>Tournez la roue <strong>une seule fois</strong> pour gagner 800 {currency}</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-500 mr-2 mt-0.5"></i>
                <span>Vos gains sont <strong>immédiatement</strong> ajoutés à votre solde Points</span>
              </li>
              <li className="flex items-start">
                <i className="ri-alert-line text-orange-500 mr-2 mt-0.5"></i>
                <span className="font-semibold text-orange-700">La roue ne peut être tournée qu'une seule fois !</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {showResult && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 shadow-2xl text-center max-w-sm mx-4">
            <div className="text-6xl mb-4">🎉</div>
            <h3 className="text-2xl font-extrabold text-gray-800 mb-2">Félicitations !</h3>
            <p className="text-gray-600 mb-2">Vous avez gagné</p>
            <p className="text-4xl font-extrabold text-green-600 mb-4">{winAmount} {currency}</p>
            <p className="text-sm text-gray-500 mb-6">✅ Vos gains ont été ajoutés à votre solde Points !</p>
            <p className="text-xs text-orange-600 font-semibold mb-4">⚠️ La roue ne peut être tournée qu'une seule fois.</p>
            <button
              onClick={() => setShowResult(false)}
              className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-8 py-3 rounded-full font-bold cursor-pointer whitespace-nowrap"
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}